import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var VolumeIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 46 46" }),
    React.createElement("path", { d: "M23.71 1.3a1.031 1.031 0 00-1.42 0C21.625 1.966 6 17.83 6 28a16.836 16.836 0 0017 17 16.836 16.836 0 0017-17C40 17.83 24.375 1.966 23.71 1.3zM23 37c-3.479 0-9-2.443-9-9a9.523 9.523 0 011-3.593C16 31.188 20.75 35.188 27.142 36A9.672 9.672 0 0123 37z" }))); };

export default VolumeIcon;
